import { MydiaryService } from 'src/app/services/mydiary.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-my-unapproved-diaries',
  templateUrl: './my-unapproved-diaries.component.html',
  styleUrls: ['./my-unapproved-diaries.component.css'],
})
export class MyUnapprovedDiariesComponent implements OnInit {
  unapproveDiaryList;
  constructor(private mydiaryService: MydiaryService) {}

  ngOnInit(): void {
    this.loadInitialDetails();
  }
  loadInitialDetails() {
    this.mydiaryService.getUnapprovedDiary().subscribe((res) => {
      console.log('unapproved diary response', res);
      this.unapproveDiaryList = res;
    });
  }
}
